import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { useLocation, useNavigate } from 'react-router';
import { Link, Button } from '@mui/material';
import Swal from 'sweetalert2';
import StudentReportDialog from '../StudentSignUp/StudentReportDialog';

export default function Success() {
  const theme = createTheme();

  const location = useLocation();
  const navigate = useNavigate();

  const { state } = location;
  console.log(state, 'state123');

  // ✅ dialog state
  const [reportsOpen, setReportsOpen] = useState(false);
  const [selectedCourseAssessmentId, setSelectedCourseAssessmentId] =
    useState<any>(null);
  useEffect(() => {
    if (state?.openReport) {
      setReportsOpen(true);
    }
  }, [state]);

  const handleCreateAccount = () => {
    const { password } = state.studentAccountData.data;

    if (password === null || password === '') {
      const { course_student_id, course_assessment_id, administration_no } =
        state.studentAccountData;

      navigate(
        `/assessment/student/${course_student_id}/${course_assessment_id}/${administration_no}/signup`,
      );
    } else {
      Swal.fire({
        text: 'Student already has an account',
        icon: 'info',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/login');
        }
      });
    }
  };

  return (
    <>
      {location?.state ? (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Container component='main' maxWidth='sm' sx={{ mb: 4 }}>
            <Paper
              variant='outlined'
              sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
            >
              <Typography variant='h5' sx={{ py: 4 }}>
                <div>
                  Congratulations, you have completed the survey. Your
                  instructor will be notified. If you would like to manage your
                  surveys on LASSO, you can create an optional student account.
                </div>

                {/* ✅ Create account */}
                <Link
                  component='button'
                  variant='body1'
                  onClick={handleCreateAccount}
                >
                  Click here to create a student account
                </Link>

                {/* ✅ Open Report Button */}
                {state?.studentAccountData?.test_status &&
                  state?.studentAccountData?.student_reports && (
                    <div style={{ marginTop: '20px' }}>
                      <Button
                        variant='contained'
                        onClick={() => {
                          setSelectedCourseAssessmentId({
                            course_student_id:
                              state.studentAccountData.course_student_id,
                            course_assessment_id:
                              state.studentAccountData.course_assessment_id,
                          });

                          setReportsOpen(true);
                        }}
                      >
                        Open Report
                      </Button>
                    </div>
                  )}
              </Typography>
            </Paper>
          </Container>

          {/* ✅ Dialog */}
          {reportsOpen && selectedCourseAssessmentId && (
            <StudentReportDialog
              open={reportsOpen}
              setOpen={setReportsOpen}
              courseData={selectedCourseAssessmentId}
            />
          )}
        </ThemeProvider>
      ) : null}
    </>
  );
}
